export const LEARN_MORE_EXIT_FALLBACK = '/sectionHome';

const LEARN_MORE_PATH = '/learn-more';

/**
 * @param {string | null | undefined} from
 * @returns {boolean}
 */
function isValidLearnMoreExitPath(from) {
  return typeof from === 'string'
    && from.startsWith('/')
    && !from.startsWith(LEARN_MORE_PATH);
}

/**
 * @param {{ state?: { from?: string } } | null | undefined} location
 * @returns {string}
 */
export function getLearnMoreExitPath(location) {
  const from = location?.state?.from;
  if (isValidLearnMoreExitPath(from)) {
    return from;
  }
  return LEARN_MORE_EXIT_FALLBACK;
}

/**
 * @param {{ pathname?: string, search?: string } | null | undefined} location
 * @returns {string}
 */
export function getCheckoutReturnPath(location) {
  const pathname = location?.pathname || LEARN_MORE_EXIT_FALLBACK;
  const search = location?.search || '';
  const path = `${pathname}${search}`;
  if (isValidLearnMoreExitPath(path)) {
    return path;
  }
  return LEARN_MORE_EXIT_FALLBACK;
}

/**
 * @param {import('react-router-dom').Location} fromLocation
 * @returns {string}
 */
export function getCurrentPath(fromLocation) {
  return `${fromLocation.pathname}${fromLocation.search}`;
}

/**
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {import('react-router-dom').Location} fromLocation
 * @param {{ replace?: boolean }} [options]
 */
export function navigateToLearnMoreRenew(navigate, fromLocation, options = {}) {
  navigate(
    { pathname: LEARN_MORE_PATH, search: '?intent=renew' },
    {
      state: { from: getCurrentPath(fromLocation) },
      replace: options.replace ?? false,
    },
  );
}

/**
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {import('react-router-dom').Location} fromLocation
 * @param {{ replace?: boolean }} [options]
 */
export function navigateToLearnMoreJoin(navigate, fromLocation, options = {}) {
  navigate(
    LEARN_MORE_PATH,
    {
      state: { from: getCurrentPath(fromLocation) },
      replace: options.replace ?? false,
    },
  );
}

/**
 * @param {{ tier?: string, showRenewInNavbar?: boolean } | null | undefined} access
 * @param {string | null} intent
 * @param {boolean} isAuthenticated
 */
export function resolveLearnMoreSecondaryLabel(access, intent, isAuthenticated) {
  const isRenewPitch = intent === 'renew' || access?.tier === 'expired';
  if (isRenewPitch) {
    return 'Continue with free skills';
  }
  if (!isAuthenticated) {
    return 'Try free skills';
  }
  if (access?.showRenewInNavbar) {
    return 'Not now';
  }
  return 'Continue with free skills';
}

/**
 * @param {{ tier?: string, showRenewInNavbar?: boolean } | null | undefined} access
 * @param {string | null} intent
 * @param {boolean} isAuthenticated
 */
export function resolveLearnMoreSecondaryHint(access, intent, isAuthenticated) {
  const isRenewPitch = intent === 'renew' || access?.tier === 'expired';
  if (isRenewPitch) {
    return 'You can still practice selected skills without renewing.';
  }
  if (!isAuthenticated) {
    return 'Explore free skills without signing in.';
  }
  if (access?.showRenewInNavbar) {
    return 'Return to the pathway.';
  }
  return 'You can still practice selected skills without subscribing.';
}
